import { render, staticRenderFns } from "./BaseFavorite.vue?vue&type=template&id=378ce7d0&"
import script from "./BaseFavorite.vue?vue&type=script&lang=js&"
export * from "./BaseFavorite.vue?vue&type=script&lang=js&"
import style0 from "./BaseFavorite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports